import styles from "./ProfileSelect.module.scss";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAppDispatch from "../../hooks/useAppDispatch";
import { useTranslation } from "react-i18next";

import { logout } from "../../store/userProfile/userProfileSlice";
import { AuthService } from "../../services/auth.service";

import selectArrow from "../../assets/images/icons/select-arrow.svg";
import useAppSelector from "../../hooks/useAppSelector";
import { setProfileImage } from "../../helper/imagePaths";
import { setLocationToInitial } from "../../store/userLocation/userLocationSlice";
import ConfirmPopup from "../shared/ConfirmPopup/ConfirmPopup";
import attentionIcon from "../../assets/images/icons/attention.svg";

const ProfileSelect = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAppSelector((state) => state.userProfileSlice);
  const [showConfirmPopupForLogout, setShowConfirmPopupForLogout] = useState(false);

  const handleAccountSettings = () => {
    navigate("/settings");
  };

  const handleProfile = () => {
    navigate("/profile");
  };

  const handleSignOut = () => {
    dispatch(logout());
    dispatch(setLocationToInitial());
    // dispatch(setUserSubscriptionToInitial());
    AuthService.logout();
    closeConfirmSignOutPopup();
    navigate("/login");
  };

  const handleWrapper = () => {
    setIsOpen(!isOpen);
  };

  const closeConfirmSignOutPopup = () => {
    setShowConfirmPopupForLogout(false);
  };

  return (
    <>
      <div className={styles.container}>
        <div onClick={handleWrapper} className={styles.wrapper}>
          <div
            className={styles.profileAvatar}
            style={{ backgroundImage: `url(${setProfileImage(user)})` }}
          ></div>
          <img
            className={`${styles.arrow} ${isOpen && styles.active}`}
            src={selectArrow}
            alt={"arrow"}
          />
          <ul className={`${styles.dropDown} ${isOpen && styles.active}`}>
            <li className={styles.item} onClick={handleProfile}>
              {t("MyProfile")}
            </li>
            <li className={styles.item} onClick={handleAccountSettings}>
              {t("AccountSettings")}
            </li>
            <li className={styles.item} onClick={() => setShowConfirmPopupForLogout(true)}>
              {t("SignOut")}
            </li>
          </ul>
        </div>
      </div>
      {showConfirmPopupForLogout && (
        <ConfirmPopup
          iconPath={attentionIcon}
          title={t("AreYouSureYouWantToLogOut")}
          description={t("YouAreAboutToLogOutOfYourAccount")}
          onClickYes={handleSignOut}
          onClickNo={closeConfirmSignOutPopup}
        />
      )}
    </>
  );
};

export default ProfileSelect;
